import React, { forwardRef } from "react";
import SelectInput from "../../select-input";
import TextInput from "../../text-input";
import {
  CryptoCurrencyTypes,
  RefsCryptoCurrency,
} from "../types/crypto-currency.types";

export interface CryptoCurrencyWithForwardRef
  extends React.ForwardRefExoticComponent<
    CryptoCurrencyTypes & React.RefAttributes<() => RefsCryptoCurrency>
  > {}

export const CryptoCurrency = forwardRef<
  () => RefsCryptoCurrency,
  CryptoCurrencyTypes
>(
  (
    { selectInput, emailInput }: CryptoCurrencyTypes,
    ref
  ): React.ReactElement => {
    const { selectInputRef, emailInputRef } = (ref as any)?.() || {};
    return (
      <>
        <SelectInput {...selectInput} ref={selectInputRef} />
        <TextInput {...emailInput} ref={emailInputRef} />
      </>
    );
  }
) as CryptoCurrencyWithForwardRef;

CryptoCurrency.displayName = "CryptoCurrency";
